import LegacyButton from "legacy/LegacyButton"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

class DashboardDatePicker extends React.Component {
  constructor(props) {
    super(props)

    this.backDay = this.backDay.bind(this)
    this.nextDay = this.nextDay.bind(this)
    this.datepickerRef = React.createRef()
  }

  componentDidMount() {
    ;["#dashboard-datepicker", "#dashboard-datepicker-xs"].forEach(
      (datepickerId) => {
        $(datepickerId)
          .datepicker()
          .on("changeDate", (e) => {
            const newDate = moment(e.target.value).format("YYYY-MM-DD")
            if (newDate !== this.props.night) {
              // just redirect, no funny business!
              window.location.href = this.props.baseNightRoute + `${newDate}`
            }
          })
      }
    )

    // set the arrows when the popup is shown
    $(this.datepickerRef.current)
      .datepicker()
      .on("show", (e) => {
        const scope = ".datepicker-dropdown"
        $("th.next", scope).html('<i class="fa-solid fa-chevron-right"></i>')
        $("th.prev", scope).html('<i class="fa-solid fa-chevron-left"></i>')
      })
  }

  backDay(event) {
    window.location.href =
      this.props.baseNightRoute +
      `${moment($("#dashboard-datepicker").val())
        .subtract(1, "days")
        .format("YYYY-MM-DD")}`
  }

  nextDay(event) {
    window.location.href =
      this.props.baseNightRoute +
      `${moment($("#dashboard-datepicker").val())
        .add(1, "days")
        .format("YYYY-MM-DD")}`
  }

  render() {
    return (
      <div>
        <div className="tonights-boats-group bs-mb-3 hidden-print">
          <input type="hidden" id="marina-slug" value={this.props.marinaSlug} />
          <LegacyButton
            type="secondary"
            className="mr-3"
            iconOnly={true}
            icon="fa-chevron-left"
            iconStyle="solid"
            onClick={this.backDay}
            id="back-day"
          />
          <div className="form-control-with-icon datepicker-tonight">
            <i className="fa-solid fa-calendar form-control-icon-left" />
            <div className="hidden-xs">
              <input
                ref={this.datepickerRef}
                className="form-control datepicker longform-datepicker"
                id="dashboard-datepicker"
                type="text"
                placeholder="mm/dd/yyyy"
                data-date-today-btn="linked"
                data-date-format="DD, MM dd, yyyy"
                value={moment(this.props.night).format("dddd, MMMM DD, YYYY")}
                readOnly
                data-provide="datepicker"
                name="date"
                data-date-autoclose="true"
                data-date-disable-touch-keyboard="true"
              />
            </div>
            <div className="visible-xs-block">
              <input
                className="form-control datepicker"
                id="dashboard-datepicker-xs"
                data-date-today-btn="linked"
                type="text"
                placeholder="mm/dd/yyyy"
                value={moment(this.props.night).format("MM/DD/YYYY")}
                readOnly
                data-provide="datepicker"
                name="date"
                data-date-autoclose="true"
                data-date-disable-touch-keyboard="true"
              />
            </div>
          </div>
          <LegacyButton
            type="secondary"
            icon="fa-chevron-right"
            iconStyle="solid"
            iconOnly={true}
            className="ml-3"
            onClick={this.nextDay}
            id="next-day"
          />
        </div>
        <h3 className="visible-print-block text-center">
          <strong>
            {moment(this.props.night).format("dddd, MMMM DD, YYYY")}
          </strong>
        </h3>
        <div className="center">
          <a
            className="btn btn-secondary bs-mb-2 bs-mb-sm-0 bs-mr-sm-3 w-1/2 md:w-auto"
            href={`${this.props.todayRoute}?arrival=true`}
            type="button"
          >
            {this.pluralize("Arrival", this.props.arrivalsCount, true)}
          </a>
          <a
            className="btn btn-secondary bs-mb-2 bs-mb-sm-0 bs-mr-sm-3 w-1/2 md:w-auto"
            href={`${this.props.todayRoute}?departure=true`}
            type="button"
          >
            {this.pluralize("Departure", this.props.departuresCount, true)}
          </a>
          <a
            className="btn btn-secondary bs-mb-2 bs-mb-sm-0 bs-mr-sm-3 w-1/2 md:w-auto"
            href={`${this.props.todayRoute}`}
            type="button"
          >{`${this.props.tonightCount} Total ${this.pluralize(
            "Boat",
            this.props.tonightCount
          )}`}</a>
          <a
            className="btn btn-secondary bs-mb-2 bs-mb-sm-0 bs-mr-sm-3 w-1/2 md:w-auto"
            href={`${this.props.waitlistRoute}`}
            type="button"
          >
            {this.pluralize("Waitlist", this.props.waitlistsCount, true)}
          </a>
        </div>
      </div>
    )
  }

  // Helper method to handle pluralization
  pluralize(word, count, showCount = false) {
    const pluralizedWord = count === 1 ? word : `${word}s`
    return showCount ? `${count} ${pluralizedWord}` : pluralizedWord
  }
}

DashboardDatePicker.propTypes = {
  night: PropTypes.string.isRequired,
  baseNightRoute: PropTypes.string.isRequired,
  todayRoute: PropTypes.string.isRequired,
  waitlistRoute: PropTypes.string.isRequired,
  arrivalsCount: PropTypes.number.isRequired,
  departuresCount: PropTypes.number.isRequired,
  tonightCount: PropTypes.number.isRequired,
  waitlistsCount: PropTypes.number.isRequired,
  marinaSlug: PropTypes.string,
}

export default DashboardDatePicker
